export default {
    gridContainer: {
        height: '100%',
        paddingLeft: 0,
        paddingRight: 0,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
    },
    gridList: {
        width: '100%',
        overflowY: 'auto',
        overflowX: 'auto',
    },
    gridTitleStyle: {
        color: '#FFFF',
        fontSize: '12px',
        whiteSpace: 'normal'
    },
    gridHeader: {
        color: 'rgb(76, 117, 188)',
        backgroundColor: 'rgb(255, 255, 255)'
    }
}



// WEBPACK FOOTER //
// ./src/Components/GridValues/GridValuesStyles.jsx